import { gsap, CustomEase } from '../../global/gsap';

const initBanner = (element) => {
    const headerLogo = document.querySelector('.header__site-link');
    const headerTitle = document.querySelector('.header__page-title');
    const media = element.querySelector('.js-banner-media');
    const content = element.querySelector('.js-banner-content');

    const headings = [];

    // Set initial content states
    if (content) {
        const h1 = content.querySelector('h1');

        if (h1) {
            headings.push(h1);
        }
        const h2 = content.querySelector('h2');

        if (h2) {
            headings.push(h2);
        }

        gsap.set(headings, {
            opacity: 0,
            x: '-15%'
        });

        gsap.set(content, {
            opacity: 1
        });
    }

    // Animate logo colour change
    if (headerLogo) {
        gsap.to(headerLogo, {
            color: '#ffffff',
            duration: 0.33,
            delay: 0.75,
            ease: CustomEase.create('custom', '0.22, 1, 0.36, 1')
        });
    }

    if (headerTitle) {
        gsap.to(headerTitle, {
            color: '#ffffff',
            duration: 1.5,
            delay: 0.75,
            ease: CustomEase.create('custom', '0.22, 1, 0.36, 1')
        });
    }

    // Fade in banner media
    if (media) {
        gsap.to(media, {
            opacity: 1,
            delay: 0.5,
            duration: 0.75
        });
    }

    // Animate in headings
    if (headings) {
        gsap.to(headings, {
            opacity: 1,
            x: 0,
            duration: 1.15,
            stagger: 0.15,
            delay: 1.25,
            ease: CustomEase.create('custom', '0.22, 1, 0.36, 1')
        });
    }
};

export { initBanner as default };
